import {Component, Input} from '@angular/core';
import { NgForOf, NgIf} from '@angular/common';
import {PerformanceCheckComponent} from '../../components/performance-check/performance-check.component';
import {environment} from '../../../environments/environment';


type Styling = {
  backgroundColor: string;
  color: string;
};

@Component({
  selector: 'app-lighthouse-details',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    PerformanceCheckComponent
  ],
  templateUrl: './lighthouse-details.component.html',
  styleUrl: './lighthouse-details.component.css'
})

export class LighthouseDetailsComponent {
  @Input() lighthouseData: any = {};
  @Input() testId: any = {};

  trackByIndex(index: number, item: any): number {
    return index;
  }

  getReportUrlFromPath(path: string, formFactor: string): string {
    const pathParts = path.split('/').pop();
    return `${environment.apiUrl}/reports/performance/lighthouse/html/${this.testId}/${formFactor}/${pathParts}`;
  }


  getReportScreenshotUrlFromPath(path: string, formFactor: string): string {
    const pathParts = path.split('/').pop();
    return `${environment.apiUrl}/reports/performance/lighthouse/screenshot/${formFactor}/${this.testId}/${pathParts}`;
  }

  getPageUrlFromReport(pageReport: any) {
    if (!pageReport) {
      return '';
    }

    if (pageReport.desktop) {
      return pageReport.desktop.url;
    }

    if (pageReport.mobile) {
      return pageReport.mobile.url;
    }
  }

  convertServerResponseTimeToString(responseTime: number): string {
    return `${Math.ceil(responseTime)} ms`;
  }


  getTTFBStyling(ttfb: number): Styling {
    if (ttfb < 800) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (ttfb < 1800) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }

  getCLSStyling(cls: number): Styling {
    if (cls < 0.1) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (cls < 0.25) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }

  getLCPStyling(lcp: number): Styling {
    if (lcp < 2500) {
      return {
        color: 'white',
        backgroundColor: 'green'
      }
    }

    if (lcp < 4000) {
      return {
        color: 'white',
        backgroundColor: 'orange'
      }
    }

    return {
      color: 'white',
      backgroundColor: 'red'
    }
  }
}
